import CashierServiceModel from "../CashierServiceModel";
import CustomerContactModel from "./CustomerContactModel";

export default class UserModel extends CashierServiceModel {

  modelName() {
    return 'users';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.create = process.env.VUE_APP_CASHIER_REPOSITORY_URL + '/api/v1/public/' + this.modelName();
    routes.exists = process.env.VUE_APP_CASHIER_REPOSITORY_URL + '/api/v1/public/' + this.modelName() + '/exists';
    return routes;
  }

  defaults() {
    return {
      id: null,
      name: null,
      email: null,
      card_brand: null,
      card_last_four: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      customer_contact: null,
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      email: (val) => (this.nullStringMutator(val)),
      card_brand: (val) => (this.nullStringMutator(val)),
      card_last_four: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  routes() {
    let base_route = process.env.VUE_APP_CASHIER_REPOSITORY_URL + '/api/v1/';
    let routes = super.routes();
    routes.exists = base_route + this.modelName() + '/exists';
    return routes;
  }

  exists() {
    let payload = this.attributes;
    let config = {
      method: this.getMethod('create'),
      url: this.getURL(this.getRoute('exists')),
      data: payload
    };
    return this.createRequest(config).send().then((response) => {
      if(response.response.status === 200) {
        return true;
      } else if(response.response.status === 204) {
        return false;
      }
    });
  }

  forceSave() {
    let payload = this.attributes;
    let config = {
      method: this.getMethod('create'),
      url: this.getURL(this.getRoute('create')),
      data: payload
    };
    return this.createRequest(config).send();
  }

  getCustomerContact() {
    return this.getRelatedModel(CustomerContactModel, 'customer_contact');
  }

}
